<template>
  <tr>
    <td class="align-top pl-0">
      <p>{{ visit.date | moment("DD/MM/YYYY") }}</p>
    </td>
    <td class="align-top pl-0">
      <p>{{ visit.typology_name }}</p>
    </td>
    <td class="fixed-column align-top">
      <p>{{ visit.text }}</p>
    </td>
    <td class="align-top">
      <p>{{ visit.author.fullname() }}</p>
    </td>
  </tr>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { Visit } from "models";

@Component
export default class TableRow extends Vue {
  @Prop()
  visit!: Visit;

  opened: boolean = false;
}
</script>

<style scoped lang="scss">
@import "../../styles/shared/variables";
@import "~bootstrap/scss/mixins";

@include media-breakpoint-down(sm) {
  .fixed-column {
    width: 150px;
  }
}

@include media-breakpoint-up(md) {
  .fixed-column {
    min-width: 400px;
  }
}

@include media-breakpoint-up(lg) {
  .fixed-column {
    min-width: 500px;
    width: 100%;
  }
}

.ellipsize {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
